import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
   button: {
      borderRadius: '20px !important',
      backgroundColor: ({ isSomeNewRecord, addedItemColor }) => `${isSomeNewRecord ? addedItemColor : '#0031'} !important`
   },
   menu: {
      height: 600,
      '& .MuiList-padding': {
         padding: '0px !important'
      }
   },
   menuHeader: {
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      alignItems: 'center',
      fontWeight: 'bold !important',
      padding: '10px 15px'
   },
   menuContent: {
      width: 350,
      minHeight: 40,
      maxHeight: 200,
      flexWrap: 'nowrap',
      overflowY: 'auto',
      overflowX: 'auto',
      paddingLeft: 15,
      paddingTop: 5,
      paddingBottom: 5,
      scrollbarWidth: 'thin',
      '& div': {
         padding: '5px 0px',
         marginTop: 5
      }
   }
})
